import t from 'tcomb';


var is_uuid_regexp = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function is_uuid(s) {
  return is_uuid_regexp.test(s);
}

// true se l'email è formalmente valida
var is_email_regexp = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i;

function is_email(s) {
  return is_email_regexp.test(s);
}

// true se s contiene solo cifre
var is_digits_regexp = /^\d*$/;

function is_digits(s) {
  return is_digits_regexp.test(s);
}

// true se è un url assoluto formalmente valido
var is_url_regexp = /^(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;

function is_url(s) {
  return is_url_regexp.test(s);
}

// true se è un url https assoluto formalmente valido
function is_https_url(s) {
  return is_url(s) && starts_with(s, 'https');
}

// true se s comincia con start
function starts_with(s, start) {
  return s.indexOf(start) === 0;
}

// true se s è un colore css
var is_color_regexp = /^#([a-f0-9]{6}|[a-f0-9]{3})$/i;

function is_color(s) {
  return is_color_regexp.test(s);
}


const Str_Format = t.subtype(t.Str, function(x) {
  return Str_Format.formats.hasOwnProperty(x);
});

Str_Format.formats = {
  email: is_email,
  url: is_url,
  https_url: is_https_url,
  digits: is_digits,
  color: is_color,
  uuid: is_uuid
};

export default Str_Format;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Str_Format.js
 **/